export const TAG = 'SessionTimeoutDialog';
